import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { createTEReport } from "../../../../services/DocumentService";

const GenerateReportModal = () => {
  const location = useLocation();
  const data = location.state?.data || {};
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [dataInput, setDataInput] = useState({
    remark: "",
    parameters: data?.measurement_sheet?.parameters?.map((param) => ({
      parameter_id: param.id,
      actual_value: "",
      evidence_file: null,
    })),
  });
  const navigate = useNavigate();

  const handleChange = (e, index = null) => {
    const { name, value, files } = e.target;

    if (index !== null) {
      setDataInput((prev) => {
        const updatedParams = [...prev.parameters];
        updatedParams[index][name] = files ? files[0] : value;
        return { ...prev, parameters: updatedParams };
      });
    } else {
      setDataInput((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitLoading(true);
      const formData = new FormData();
      formData.append("circular_id", data.id);
      formData.append("remarks", dataInput.remark);

      dataInput.parameters.forEach((param, index) => {
        formData.append(
          `parameters[${index}][parameter_id]`,
          param.parameter_id
        );
        formData.append(
          `parameters[${index}][actual_value]`,
          param.actual_value
        );
        if (param.evidence_file) {
          formData.append(
            `parameters[${index}][evidence_file]`,
            param.evidence_file
          );
        }
      });

      const response = await createTEReport(formData);
      toast.success(response.data.message);
      navigate(`/circular/${data.id}`);
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/te-sheet/${data?.measurement_sheet?.id}`);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row px-2">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm btn-circle"
                      onClick={() => navigate(`/circular/${data?.id}`)}
                    >
                      <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <h4 className="mb-0 ms-2">Generate TE Report</h4>
                  </div>
                </div>
              </div>

              <div className="card-body">
                {" "}
                <form>
                  {dataInput?.parameters?.map((param, index) => (
                    <div key={index} className="border p-3 rounded mb-3">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <p>
                            <strong>Parameter:</strong>{" "}
                            {
                              data.measurement_sheet?.parameters[index]
                                .parameter_name
                            }
                          </p>
                          <label className="form-label fw-bold">
                            Actual Value <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Actual Value"
                            name="actual_value"
                            value={param.actual_value}
                            onChange={(e) => handleChange(e, index)}
                          />
                        </div>
                        <div className="col-md-6">
                          <p>
                            <strong>Expected Value:</strong>{" "}
                            {
                              data.measurement_sheet?.parameters[index]
                                .expected_value
                            }
                          </p>
                          <label className="form-label fw-bold">
                            Upload Evidence{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            name="evidence_file"
                            onChange={(e) => handleChange(e, index)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="row g-3 mb-4">
                    <div className="col-md-12">
                      <label className="form-label fw-bold">
                        Remark <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="remark"
                        value={dataInput.remark}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button
                      type="button"
                      className="btn btn-primary me-3"
                      onClick={handleSubmit}
                      disabled={isSubmitLoading}
                    >
                      {isSubmitLoading ? "Submitting..." : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateReportModal;
